import React, { useCallback, useEffect, useState } from "react";
import { LayoutGrid, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { layoutsApi } from "../lib/windowLayouts";

// FAZ C — "Uygulamayı açtığımda son pencere düzenini geri yükle" anahtarı.
// VARSAYILAN KAPALI: kullanıcı temiz açılış istiyor, ama seçenek istedi.
export const LayoutAutoRestoreCard = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [lastId, setLastId] = useState(null);

  useEffect(() => {
    let iptal = false;
    layoutsApi
      .getPrefs()
      .then((d) => {
        if (iptal) return;
        setEnabled(!!d.auto_restore);
        setLastId(d.last_layout_id || null);
      })
      .catch(() => { /* sessiz */ })
      .finally(() => { if (!iptal) setLoading(false); });
    return () => { iptal = true; };
  }, []);

  const degistir = useCallback(async () => {
    const yeni = !enabled;
    setSaving(true);
    try {
      await layoutsApi.setPrefs({ auto_restore: yeni, last_layout_id: lastId });
      setEnabled(yeni);
      toast.success(
        yeni ? "Açılışta son düzen geri yüklenecek" : "Açılışta temiz başlanacak",
      );
    } catch {
      toast.error("Ayar kaydedilemedi");
    } finally {
      setSaving(false);
    }
  }, [enabled, lastId]);

  return (
    <div
      data-testid="layout-autorestore-card"
      className="glass-panel rounded-lg border border-sertex-cyan/20 p-3 space-y-2"
    >
      <div className="hud-text text-[10px] text-sertex-cyan flex items-center gap-1.5">
        <LayoutGrid className="h-3.5 w-3.5" /> PENCERE DÜZENİ
      </div>
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="text-sm text-sertex-text">
            Uygulamayı açtığımda son pencere düzenini geri yükle
          </div>
          <div className="text-xs text-sertex-textMuted mt-0.5">
            Kapalıyken uygulama temiz açılır. Düzenleri Görevler panelindeki
            "DÜZENLER" düğmesinden kaydedebilirsiniz.
          </div>
        </div>
        <button
          onClick={degistir}
          disabled={loading || saving}
          data-testid="layout-autorestore-toggle"
          aria-pressed={enabled}
          className={`shrink-0 w-14 h-7 rounded-full border transition-colors relative disabled:opacity-50 ${
            enabled
              ? "bg-sertex-cyan/30 border-sertex-cyan"
              : "bg-sertex-surface border-sertex-textMuted/40"
          }`}
        >
          <span
            className={`absolute top-0.5 h-5 w-5 rounded-full transition-all ${
              enabled ? "left-8 bg-sertex-cyan" : "left-0.5 bg-sertex-textMuted"
            }`}
          />
          {(loading || saving) && (
            <Loader2 className="h-3 w-3 animate-spin absolute -right-5 top-2 text-sertex-textMuted" />
          )}
        </button>
      </div>
    </div>
  );
};

export default LayoutAutoRestoreCard;
